import EmptyTemplate from '../empty-result/empty-result.twig';
import NewsTemplate from '../../sections/news-list/templates/news-list.twig';
import {Utils} from '../../common/scripts/utils';

class Search {
    constructor(options) {
        this.template = '';
        this.openBtn = options.openBtn;
        this.moreButton = options.moreButton || null;
        this.wrapper = options.wrapper;
        this.contentWrapper = options.contentWrapper;
        this.search = this.wrapper.querySelector('.j-search');
        this.overlay = this.search.querySelector('.j-search-overlay');
        this.searchContent = this.search.querySelector('.j-search-content');
        this.searchField = this.search.querySelector('.j-search-field');
        this.searchBtn = this.search.querySelector('.j-search-button');
        this.searchError = this.searchContent.querySelector('.j-search-error');
        this.url = this.search.dataset.url;
        this.page = this.search.dataset.page;
        this.tags = options.tags || null;
        this.tagsItem = options.tagsItem || null;
        this.years = options.years || null;
        this.yearsItem = options.yearsItem || null;
    }

    init() {
        this._bindEvents();
    }

    _bindEvents() {
        if (this.openBtn) {
            this._showField();
        }

        this._initBtn();
    }

    /**
     * Показываем окно поиска
     */
    _showField() {
        this.openBtn.addEventListener('click', () => {
            if (Utils.getWindowWidth() < 1280) {
                Utils.bodyFixed();
            }

            if (Utils.getWindowWidth() >= 1280) {
                this.openBtn.classList.add('is-hide');
            }

            this.search.classList.add('is-open');
            this.overlay.addEventListener('click', this._closeMobile.bind(this));
        });
    }

    /**
     * Скрываем поиск на мобильных
     */
    _closeMobile() {
        this.search.classList.remove('is-open');
        Utils.bodyStatic();
    }

    _initBtn() {
        this.searchBtn.addEventListener('click', () => {
            this._search();
        });

        this.searchField.addEventListener('keypress', (event) => {
            if (event.code === 'Enter') {
                this._search();
                this.searchField.blur();
            }
        });
    }

    /**
     * Инициализирует поиск
     */
    _search() {
        const searchText = this.searchField.value;

        if (this._validation(searchText)) {
            this._sendRequest(searchText);

            if (Utils.getWindowWidth() < 1280) {
                this._closeMobile();
            }
        }
    }

    /**
     * Устанавливает шаблон применяемые для результатов поиска
     * @param {array} items - имя страницы
     */
    _setTemplate(items) {
        if (items.length === 0) {
            this.template = EmptyTemplate;
        } else if (this.page === 'news') {
            this.template = NewsTemplate;
        }
    }

    _sendRequest(searchText) {
        const that = this;
        const tagsData = [];
        let yearsData = '';

        // Если есть теги то передаем и их в запрос
        if (that.tags) {
            tagsData.push(...that._getTag());
        }

        if (that.years) {
            yearsData = that.years.querySelector(`${that.yearsItem}.is-active`).dataset.year;
        }


        const formData = this._createFormData(searchText, tagsData, yearsData);

        Utils.send(formData, that.url, {
            success(response) {
                const {data} = response;

                that._setTemplate(data.items);

                that._checkMore(data.more);

                Utils.clearHtml(that.contentWrapper);

                that._insertItems(data);

                that.wrapper.classList.add('is-searched');
            }
        }, 'POST');
    }

    // Получаем активные теги
    _getTag() {
        const selectedTags = [];

        const allTags = Array.from(this.tags.querySelectorAll(this.tagsItem));

        const filteredTags = allTags.filter((tag) => {
            return tag.classList.contains('is-active');
        });

        if (filteredTags.length) {
            filteredTags.forEach((item) => {
                selectedTags.push(item.dataset.tag);
            });
        }

        return selectedTags;
    }

    /**
     * Формируем FormData для отправки на сервер
     * @param {string} searchText - поисковая фраза
     * @param {array} tagsData - выбранный тег
     * @param {string} yearsData - выбранный год
     * @returns {object} - возвращает сформированную FormData
     */
    _createFormData(searchText, tagsData, yearsData) {
        const formData = new FormData();

        formData.append('search', searchText);

        formData.append('tags', tagsData);

        formData.append('year', yearsData);


        // Сбрасываем на 0 количество показанных новостей при смене года
        formData.append('count', 0);
        formData.append('page', this.page);

        return formData;
    }

    /**
     * Показывает или скрывает кнопку показать еще
     * @param {boolean} more - показывать или нет кнопку Показать еще
     */
    _checkMore(more) {
        if (this.moreButton.dataset.page) {
            this.moreButton.dataset.page = 2;
        }

        this.moreButton.style.display = more ? 'inline-flex' : 'none';
    }

    /**
     * Вставляет новые элементы в контейнер
     * @param {object} data - данные для заполнения шаблона
     * @private
     */
    _insertItems(data) {
        this.contentWrapper.insertAdjacentHTML('beforeend', this.template(data));
    }

    /**
     *
     * @param {string} text - введенная поисковая фраза
     * @returns {boolean} - результат валидации поисковой фразы
     */
    _validation(text) {
        if (text.length < 3) {
            this.searchError.classList.add('is-active');

            return false;
        }

        this.searchError.classList.remove('is-active');

        return true;
    }
}

export default Search;
